import { render, staticRenderFns } from "./UcAddressTypeBadge.yaml?vue&type=template&id=6fa70e8a&component"
import script from "./UcAddressTypeBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcAddressTypeBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports